<div class="dialog">
  <h4 mat-dialog-title>{{ 'common_modify' | translate }}</h4>
  <form #form="ngForm" [appEnterToSave]="data.ratio">
    <mat-form-field>
      <mat-label>{{ 'dialog_edit_composition_field_ratio' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data.ratio" name="ratio" #ratio="ngModel" min="0" required />
      <mat-error *ngIf="ratio.errors?.required" [innerHTML]="'dialog_edit_composition_error_ratio' | translate"></mat-error>
      <mat-error *ngIf="ratio.errors?.min" [innerHTML]="'dialog_edit_composition_error_ratio_negative' | translate"></mat-error>
    </mat-form-field>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data.ratio" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
